import axios from 'axios';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueProgressBar from 'vue-progressbar';
import Toasted from 'vue-toasted';
import App from './App.vue';
import Loading from './components/Loading';
import './registerServiceWorker';
import router from './router';

Vue.use(VeeValidate);
Vue.use(Loading);
Vue.component('Admin', () => import(`@/layouts/Authenticated.vue`));
Vue.component('Default', () => import(`@/layouts/Default.vue`));
Vue.use(VueProgressBar, {
  color: '#38c172',
  failedColor: 'red',
  thickness: '4px'
});
Vue.use(Toasted, {
  position: 'top-left',
  duration: 6000,
  fitToScreen: true,
  className: 'p-8',
  fullWidth: true
});
axios.defaults.baseURL = '/client-portal';

Vue.config.productionTip = false;
Vue.config.devtools = true;

const app = new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

axios.interceptors.request.use(
  config => {
    app.$Progress.start(); // for every request start the progress

    return config;
  },
  error =>
    // Do something with request error
    Promise.reject(error)
);
axios.interceptors.response.use(
  response => {
    app.$Progress.finish();
    return response;
  },
  error => {
    app.$Progress.fail();
    if (error.response.status === 401) {
      window.location.href =
        process.env.NODE_ENV === 'production' ? '/client-portal' : '/';
      return;
    }

    return Promise.reject(error);
  }
);
